import React from "react";
import styled from "styled-components";
import AddButton from "components/Global/Buttons/AddButton";
import { IconButton, Grid, Table, TableHead, TableBody, TableRow, TableCell } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";

export const PositionedMoreVert = styled(MoreVert)`  
  &&& {    
    fill: #ccc;
  }
  border-radius: 8px;  
  &&:hover {   
    fill: #999; 
    cursor:pointer;    
  }
`;
export const StyledTableHead = styled(TableHead)`
  && {
    border-bottom: 3px solid #eee;
  }
`;
export const GuarantorTableWrapper = styled(Grid)`
  &&& {
    max-width: 1270px;
    padding-right:20px;
  }
`;
export const AddGuarantorButton = styled(AddButton)`
  &&& {
    margin-left:0;
    margin-top:8px;
  }
`;
export const HeaderCell = styled(TableCell)`
  &&& {
    color:#202020;    
    font-size:17px;  
  }
`;
export const OptionsCell = styled(TableCell)`
  &&& {
    display:flex;
    justify-content: flex-end;
    margin-bottom: -1px;
  }
`;
export const RowOptionsCell = styled(OptionsCell)`
  &&&& {
    height:48px;
    align-items:center;
  }
`;
export const EmptyGuarantors = styled.div`
  padding:12px;  
  align-self:stretch;
  background:#f2f2f2;
  color:#999999;
`;
export const styles = theme => ({
  headerRow: {
    background: "#f9f9f9",
    height: "40px"
  },
  startCell: {
    padding: "8px"
  },
  endCell: {
    padding: "8px"
  },
  iconButton: {
    maxHeight: "40px",
    "&:hover": {
      background: "none"
    }
  }
});
